import React, { forwardRef } from 'react';
import CustomInput from '@/components/custom-input';
import type { inputProps } from '@/components/custom-input';

export interface StyledInputProps extends Omit<inputProps, 'containerStyles' | 'inputStyles'> {
  containerStyles?: string;
  inputStyles?: string;
}

const StyledInput = forwardRef<HTMLInputElement, StyledInputProps>(
  ({ containerStyles, inputStyles, error, ...props }, ref) => {
    return (
      <CustomInput
        ref={ref}
        containerStyles={containerStyles || "!rounded mt-1"}
        inputStyles={inputStyles || "!h-[48px]"}
        error={error}
        {...props}
      />
    );
  }
);

StyledInput.displayName = 'StyledInput';

export { StyledInput };

